import { useMemo, useState } from "react";

// Snowfall-only premium winter atmosphere for the authenticated app.
// Pure CSS keyframes (transform/opacity). pointer-events:none. Sits BEHIND content (shell content = z-10).
// Two depth layers: soft larger foreground flakes + smaller fainter background flakes.
export default function WinterDecor() {
  const reduced = useState(() => typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)[0];
  const mobile = useState(() => typeof window !== "undefined" && window.innerWidth < 640)[0];

  const { near, far } = useMemo(() => {
    const mk = (n, isNear) => Array.from({ length: n }, (_, i) => ({
      id: `${isNear ? "n" : "f"}${i}`,
      left: +(Math.random() * 100).toFixed(2),
      size: isNear ? (5 + Math.random() * 6) : (2 + Math.random() * 2.2),   // near 5-11px, far 2-4px
      dur: isNear ? (10 + Math.random() * 7) : (16 + Math.random() * 12),    // slow, natural
      delay: -(Math.random() * 24).toFixed(2),
      dx: (Math.random() * 70 - 35).toFixed(0) + "px",                        // horizontal drift
      op: isNear ? (0.55 + Math.random() * 0.35).toFixed(2) : (0.25 + Math.random() * 0.22).toFixed(2),
      blur: isNear ? (Math.random() * 0.8).toFixed(2) : (1 + Math.random() * 0.8).toFixed(2),
    }));
    return { near: mk(mobile ? 14 : 28, true), far: mk(mobile ? 10 : 22, false) };
  }, [mobile]);

  if (reduced) return null;

  const Flake = (f, near) => (
    <span key={f.id} className="absolute top-0 rounded-full bg-white" style={{
      left: f.left + "%",
      width: f.size, height: f.size,
      filter: `blur(${f.blur}px)`,
      boxShadow: near ? "0 0 6px rgba(255,255,255,0.75)" : "none",
      animation: `zsnow ${f.dur}s linear ${f.delay}s infinite`,
      "--dx": f.dx, "--op": f.op,
    }} />
  );

  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
      <style>{`
        @keyframes zsnow{0%{transform:translateY(-12vh) translateX(0);opacity:0}8%{opacity:var(--op,.6)}50%{transform:translateY(50vh) translateX(var(--dx,10px))}92%{opacity:var(--op,.6)}100%{transform:translateY(112vh) translateX(0);opacity:0}}
      `}</style>
      {far.map((f) => Flake(f, false))}
      {near.map((f) => Flake(f, true))}
    </div>
  );
}
